import * as React from 'react';
import DataCenterMain from '../components/datacenters-list/DataCenterMain';

export interface DataCenterPageProps {
    
}
 
const DataCenterPage: React.FC<DataCenterPageProps> = () => {
    return ( <React.Fragment>
        <DataCenterMain/>
    </React.Fragment> );
}
 
export default DataCenterPage;